import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadPeriodos } from '../store/actions/Periodos';

export const useLoadPeriodos = () => {
    const dispatch = useDispatch();
    const periodos = useSelector((store) => store.periodos);

    useEffect(() => {
        const getPeriodos = async () => {
            await dispatch(loadPeriodos());
        };

        getPeriodos();
    }, [dispatch]);

    return periodos;
};

export default useLoadPeriodos;